export enum PaymentBehaviourInsightsActionTypes {
    GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST = '@@paymentBehaviourInsights/GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST',
    GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_SUCCESS = '@@paymentBehaviourInsights/GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_SUCCESS',
    GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_ERROR = '@@paymentBehaviourInsights/GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_ERROR',
    SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST = '@@paymentBehaviourInsights/SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST',
    SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_RESPONSE = '@@paymentBehaviourInsights/SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_RESPONSE',
}

export interface PaymentBehaviourInsightsState {
    data: PaymentBehaviourInsightsConfiguration;
    loading: boolean;
    saveLoading: boolean;
    errorMessages: string[];
}

export interface PaymentBehaviourInsightsConfiguration {
    CompanyConfigBehaviourInsights: CompanyConfigBehaviourInsights[];
    ComparisonPeriod: number | null | undefined;
    EvaluationScheduleType: number | null | undefined;
    EvaluationTiming: number | null | undefined;
    EvaluationTimingDay: number | null | undefined;
    NextEvaluationDate: string | null | undefined;
}

export interface CompanyConfigFile {
    CompanyConfigBehaviourInsights: CompanyConfigBehaviourInsights[];
    ComparisonPeriod: number;
    EvaluationScheduleType: number;
    EvaluationTiming: number;
    EvaluationTimingDay: number;
}

export interface CompanyConfigBehaviourInsights {
    WorkflowId: string;
    State: string;
}
